import { type Room } from "matrix-js-sdk/src/matrix";

import { type RoomEchoChamber } from "./RoomEchoChamber";
import { EchoStore } from "./EchoStore";

/**
 * Semantic access to local echo
 */
export class EchoChamber {
    private constructor() {}

    public static forRoom(room: Room): RoomEchoChamber {
        return EchoStore.instance.getOrCreateChamberForRoom(room);
    }
}
